import { onError } from "@apollo/client/link/error";

export const errorLink = onError((error) => {
  // TODO: Sentry error reporting
});
